import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import expandedSectionStyles from '../ExpandedSectionStyles';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import dealPriceAccessor from '../../../../../../../common/service/dealPriceAccessor';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import ICarConfigOption from '../../../../../../../../../common/model/ICarConfigOption';
import { CustomiseSections } from '../../../../../../../common/enum/CustomiseSections';
import OptionItem from './OptionItem';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface IAccessoryPackSectionProps {
  packs: ICarConfigOption[];
  removeAction: (category: string, optionId?: string) => void;
  isSecondaryCurrencyDisplay: boolean;
}

const AccessoryPackSection: FunctionComponent<IAccessoryPackSectionProps> = ({
  packs,
  removeAction,
  isSecondaryCurrencyDisplay,
}) => {
  const styles = expandedSectionStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  return (
    <Grid item={true}>
      <Typography variant={'body1'} className={clsx([styles.bolded, styles.subtitle])}>
        <Translation id={'spc.customise.accessories.packs'} />
      </Typography>
      {packs.map((option: ICarConfigOption) => {
        const price: IPrice = isSecondaryCurrencyDisplay
          ? dealPriceAccessor.getSecondaryPrice(option.prices, priceDisplay)
          : dealPriceAccessor.getPrimaryPrice(option.prices, priceDisplay);

        return (
          <OptionItem
            key={option.id}
            option={option}
            price={price}
            category={CustomiseSections.PACKS}
            removeAction={removeAction}
            decimalScale={priceDisplay.primaryOptions.decimalScale}
          />
        );
      })}
    </Grid>
  );
};

export default AccessoryPackSection;
